import {
  getBuyerContactAgent,
  getBuyerDetails,
  getVendorContactAgent,
} from 'api/apiService';
import EnhancedBuyerTable from 'component/ContactTab/BuyerTable';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import { useContext, useEffect, useState } from 'react';
import Loading from 'assets/images/loading.png';
import { Grid, Box, Typography } from '@mui/material';
const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'role',
    numeric: true,
    disablePadding: false,
    label: 'Role',
  },
  {
    id: 'contact',
    numeric: true,
    disablePadding: false,
    label: 'Contact',
  },

  {
    id: 'Exp',
    numeric: true,
    disablePadding: false,
    label: 'Exp',
  },
  {
    id: 'Profile',
    numeric: true,
    disablePadding: false,
    label: 'Profile',
  },

  {
    id: 'Buyers Requirements',
    numeric: true,
    disablePadding: false,
    label: 'Buyers Requirements',
  },
  {
    id: 'Tag',
    numeric: true,
    disablePadding: false,
    label: 'Tag',
  },
  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];

const ContactBuyerTabItem = ({
  userType,
  setSelectedRows,
  onDataLoad,
  selectedRows,
  searchText,
}) => {
  const [properties, setProperties] = useState([]);
  const { setIsLoadingPage } = useContext(LoaderContext);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const apiFunction = async () => {
      var mounted = true;
      if (userType == 'Buyer') {
        await getBuyerContactAgent().then((resp) => {
          setProperties(resp);
        });
      } else if (userType == 'Vendor') {
        await getVendorContactAgent().then((resp) => {
          setProperties(resp);
        });
      } else {
        await getBuyerDetails().then((resp) => {
          if (mounted) {
            setProperties(resp);
          }
        });
      }
      setLoader(false);
      return () => (mounted = false);
    };
    apiFunction();
  }, []);

  useEffect(() => {
    const dataToPass = Array.isArray(properties?.data)
      ? properties.data
      : Array.isArray(properties?.userDetails)
      ? properties.userDetails
      : [];

    if (dataToPass.length > 0 && onDataLoad) {
      onDataLoad(dataToPass);
    }
  }, [properties, onDataLoad]);

  const contactList = Array.isArray(properties?.userDetails)
    ? properties.userDetails
    : Array.isArray(properties?.data)
    ? properties.data
    : [];

  const filteredUserDetails = contactList.filter((item) =>
    `${item?.user?.userName || ''} ${item?.user?.userSurName || ''}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const filteredProperties = {
    ...properties,
    userDetails: filteredUserDetails,
  };

  return (
    <>
      {loader ? (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'left',
            height: '100%',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Box>
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '100px', width: '100px' }}
            />
          </Box>
          <Typography sx={{ fontFamily: 'poppins' }}>Loading...</Typography>
        </Grid>
      ) : searchText.trim() !== '' && filteredUserDetails.length === 0 ? (
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            fontFamily: 'Poppins',
            padding: '20px',
          }}
        >
          No Search contact available
        </Typography>
      ) : (
        <>
          {properties?.status == 1 ? (
            <EnhancedBuyerTable
              headCells={headCells}
              properties={filteredProperties}
              setProperties={setProperties}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
            />
          ) : (
            <Typography
              sx={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: '14px',
                fontFamily: 'poppins',
                padding: '20px',
              }}
            >
              Buyer Not Available
            </Typography>
          )}
        </>
      )}
    </>
  );
};
export default ContactBuyerTabItem;
